//Frontend
import { apiRequest } from "../util/apiUtils";

export const getaddressList = async (params) => {
  try {
    const res = await apiRequest("get", `profile/address`, {
      queries: params,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const addressAddEdit = async (payload) => {
  try {
    const res = await apiRequest(
      payload?.id ? "patch" : "patch",
      `profile/${payload?.addressId ? "update-address" : "add-address"}`,
      {
        body: payload,
      }
      // "multipart/form-data"
    );

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const addressDelete = async (payload) => {
  try {
    const res = await apiRequest("patch", `profile/delete-address`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};

export const addressStatusChange = async (payload) => {
  try {
    const res = await apiRequest("patch", `profile/default-address`, {
      body: payload,
    });

    return res?.data;
  } catch (err) {
    throw err;
  }
};
